import {pitchAngle} from "./pitch-angle.ts";
import {power} from "./power.ts";
import {temperature} from "./temperature.ts";
import {wind} from "./wind.ts";
import {lines} from "./lines";
import {events} from "./events";

const sampleData = {
    pitchAngle,
    power,
    temperature,
    wind,
    lines,
    events
}

export default sampleData;
